<template>
    <div>
        <a :href="exam.uri" class="card exam">
            <div class="card-body">
                <div class="text-center img-wrap" v-if="exam.vod_courses && exam.vod_courses[0]">
                    <img class="card-img-top-virtuoso h-auto"
                         :src="exam.vod_courses[0] && exam.vod_courses[0].imageUris && exam.vod_courses[0].imageUris.cardThumb ? exam.vod_courses[0].imageUris.cardThumb.url : ''"
                         :alt="exam.name"
                         loading="lazy"
                         width="320"
                         height="180">
                </div>

                <template v-if="exam.vod_courses && exam.vod_courses[0] && exam.vod_courses[0].teachers">
                    <template v-if="exam.vod_courses[0].teachers.length > 0">
                        <div class="teacher-list grey-subtitle">{{ exam.vod_courses[0].teachers[0].name }}</div>
                    </template>
                </template>

                <h2 class="card-title mb-0">{{ exam.name }}</h2>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        examData: {
            type: Object,
            default: () => ({}),  // Provide an empty object as default
        },
    },

    data() {
        return {
            exam: {},
            isSubscribed: false,
        }
    },

    mounted() {
        // User logged in?
        if (window.virtuoso) {
            this.isSubscribed = window.virtuoso.is_subscribed;
        }

        if (this.examData) {
            this.exam = this.examData;
        }
    },
}
</script>
